<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="students"
      :items-per-page="25"
      class="elevation-1"
      :search="search"
      v-if="students"
    >     
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "Programme",

  data: () => ({
    drawer: null,
    headers: [
      { text: "code", value: "code" },
      { text: "Label", value: "name" },
    ],
    students: null,
    search: null,
  }),
  mounted() {
    this.axios
      .get("/programmes")
      .then((response) => (this.students = response["data"]));
  },
};
</script>